import getPrefixedCookieName from './getPrefixedCookieName';

/**
 * References:
 * - https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 */

/**
 * Get the value of a cookie
 * @param {string} name - The name of the cookie
 * @return {string} The cookie value
 */
const getCookie = (unprefixedName) => {
  const name = getPrefixedCookieName(unprefixedName);
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
};

export default getCookie;
